export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6906.05f736f6.jpg";